import { getSupabaseClient, normalizeSupabaseError } from "./supabaseClient.js";
import { splitHonorarios } from "./pdf/generateContrato.js";

const TABLE = "event_payments";

function throwSupabase(error, context = "") {
    if (!error) return;
    const n = normalizeSupabaseError(error);
    const msg = context ? `${context}: ${n.message}` : n.message;
    throw new Error(msg);
}

export async function listPaymentsByTeam(teamId) {
    if (!teamId) return [];
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
        .from(TABLE)
        .select("*")
        .eq("team_id", teamId)
        .order("payment_date", { ascending: true });

    if (error) {
        console.warn("Error fetching team payments:", error);
        return [];
    }
    return data || [];
}

export async function listPaymentsByEvent(eventId) {
    if (!eventId) return [];
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
        .from(TABLE)
        .select("*")
        .eq("event_id", eventId)
        .order("payment_date", { ascending: true });

    // Si falla porque no existe la tabla, retornamos vacio para no romper la UI, 
    // pero logueamos error.
    if (error) {
        console.warn("Error fetching payments (table might not exist yet):", error);
        return [];
    }
    return data || [];
}

/**
 * Señal de un evento: la pactada (porcentaje de reserva del precio, con IVA)
 * frente a la registrada (pagos de tipo "advance"). Sin precio no hay cifra
 * pactada y basta con que haya alguna señal.
 * @returns {Promise<{ expected: number, received: number, covered: boolean }>}
 */
export async function getDepositStatus(event) {
    const payments = await listPaymentsByEvent(event?.id);
    const received = Math.round(payments
        .filter((p) => p.payment_type === "advance")
        .reduce((acc, p) => acc + (Number(p.amount) || 0), 0) * 100) / 100;
    const expected = Number(event?.amount) > 0
        ? splitHonorarios(Number(event.amount), event.deposit_pct).reservaTotal
        : 0;
    // El centimo de margen absorbe redondeos al teclear el importe.
    return { expected, received, covered: received > 0 && received + 0.01 >= expected };
}

export async function createPayment(payload) {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
        .from(TABLE)
        .insert(payload)
        .select()
        .single();
    throwSupabase(error, "Error creando pago");
    return data;
}

export async function updatePayment(id, payload) {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
        .from(TABLE)
        .update(payload)
        .eq("id", id)
        .select()
        .single();
    throwSupabase(error, "Error actualizando pago");
    return data;
}

export async function deletePayment(id) {
    const supabase = getSupabaseClient();
    const { error } = await supabase
        .from(TABLE)
        .delete()
        .eq("id", id);
    throwSupabase(error, "Error eliminando pago");
    return true;
}
